export default __webpack_public_path__ + "static/media/image_south_korea.7bcb8e2b.png";